/**
 * Global error capturing setup for the Beehive application
 */

// Use dynamic import to avoid mixing static and dynamic imports for errorReporting

/**
 * Initialize global error capturing when the app starts
 */
export const initializeGlobalErrorCapturing = (): void => {
  if (typeof window !== 'undefined') {
    // Dynamically import setup to keep errorReporting in its own chunk
    import('./errorReporting').then(({ setupGlobalErrorCapturing }) => {
      try {
        setupGlobalErrorCapturing();
      } catch (e) {
        // no-op: avoid failing app startup if error reporting init throws
      }
    });
    
    const originalConsoleError = console.error;
    console.error = (...args: unknown[]) => {
      const errorMessage = args.join(' ');
      if (errorMessage.includes('React') || errorMessage.includes('component')) {
        import('./errorReporting').then(({ reportError }) => {
          reportError({
            source: 'ReactErrorBoundary',
            error: errorMessage,
            details: { 
              args: args.length,
              type: 'console_error_intercept'
            }
          });
        });
      }
      
      originalConsoleError.apply(console, args);
    };
    
    console.log('[Resilience] Global error capturing and React error interception initialized');
  }
};
